import React, { useState, useEffect } from "react";
import { Link as MuiLink, Fade, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Resume from "../../settings/resume.json";
import { Logo } from "./Logo";
import { Today } from "../content/Today";

const useStyles = makeStyles((theme) => ({
  logoLink: {
    position: "fixed",
    top: theme.spacing(4),
    left: theme.spacing(4),
    zIndex: theme.zIndex.appBar + 1,
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    borderRadius: 8,
    padding: theme.spacing(1),
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
    },
    [theme.breakpoints.down("sm")]: {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },

  greetingContainer: {
    position: "fixed",
    top: "10%",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: theme.zIndex.tooltip + 1,
    width: "max-content",
    padding: theme.spacing(2),
    background: "rgba(0, 0, 0, 0.6)",
    borderRadius: "12px",
    backdropFilter: "blur(6px)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.3)",
    [theme.breakpoints.down("xs")]: {
      top: "12%",
      padding: theme.spacing(1.5),
    },
  },

  greeting: {
    fontSize: "1.8rem",
    color: "#fff",
    fontWeight: 600,
    letterSpacing: "1px",
    textShadow: "0 0 8px rgba(255,255,255,0.6)",
    animation: `$popIn 800ms ease-out`,
    fontFamily: "'Space Mono', monospace",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.2rem",
    },
  },

  "@keyframes popIn": {
    "0%": {
      transform: "scale(0.8)",
      opacity: 0,
    },
    "100%": {
      transform: "scale(1)",
      opacity: 1,
    },
  },
}));

export const LogoLink = () => {
  const classes = useStyles();
  const [showGreeting, setShowGreeting] = useState(true);
  const [currentGreeting, setCurrentGreeting] = useState("welcome");

  useEffect(() => {
    const timeout1 = setTimeout(() => setCurrentGreeting("time"), 2500);
    const timeout2 = setTimeout(() => setShowGreeting(false), 5000);
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, []);

  return (
    <>
      <MuiLink
        href={Resume.basics.url}
        underline="none"
        color="inherit"
        className={classes.logoLink}
        aria-label="Home"
      >
        <Logo />
      </MuiLink>

      <Fade in={showGreeting} timeout={500} unmountOnExit>
        <Box className={classes.greetingContainer}>
          <div className={classes.greeting}>
            {currentGreeting === "welcome" ? (
              "Welcome to my space"
            ) : (
              <Today variant="time" />
            )}
          </div>
        </Box>
      </Fade>
    </>
  );
};
